import styled from 'styled-components'

export const SidebarContainer = styled.div<{ sidebarOpen: boolean }>`
  position: fixed;
  z-index: 25;
  margin-top: 85px;
  top: 0;
  left: -350px;
  width: 350px;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  bottom: 0;
  transition: all 0.25s ease-in;
  ${({ sidebarOpen }) =>
    sidebarOpen &&
    `
    left: 0px;
    box-shadow: 18px 4px 35px rgba(0, 0, 0, 0.02);
  `}
`
export const SidebarMenu = styled.div`
  width: 100%;
  padding: 1.5rem 0;
`

export const SidebarButton = styled.div<{ sidebarOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 7.8rem;
  background-color: ${({ theme }) => theme.colors.primary};
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  cursor: pointer;
  transition: all 0.25s ease-in;
  position: absolute;
  right: -24px;
  top: 25%;
  /* z-index: 9999; */
  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryAccent};
  }

  img {
    transform: rotate(180deg);
    ${({ sidebarOpen }) =>
      sidebarOpen &&
      `
      transform: rotate(0deg);
    `}
  }
`

export const SidebarAvatarContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
`
